<template>
  <div id="more-info">
    <div class="editing-wrap"
         v-loading="loading">
      <div class="information-wrap">
        <div class="fill-block">
          <el-form :model="profileForm"
                   ref="profileForm"
                   label-width="100px"
                   class="demo-ruleForm"
                   label-position="top"
                   disabled
                   :show-message="false">
            <el-form-item label="Employee ID:"
                          prop="teaNo">
              <el-input v-model="profileForm.teaNo"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Nickname:"
                          prop="userName"
                          required>
              <el-input v-model="profileForm.userName"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Full Name:"
                          prop="realName"
                          required>
              <el-input v-model="profileForm.realName"
                        disabled> </el-input>
            </el-form-item>
            <el-form-item label="Sex"
                          prop="sex"
                          required>
              <el-select v-model="profileForm.sex"
                         placeholder="sex"
                         disabled>
                <el-option value="0"
                           label="female">
                </el-option>
                <el-option value="1"
                           label="male">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="ID/PASSPORT Number:"
                          prop="idCardNum"
                          required>
              <el-input v-model="profileForm.idCardNum"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Nationality:"
                          prop="nationality">
              <el-input v-model="profileForm.nationality"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Telephone Number:"
                          prop="phone"
                          required>
              <el-input v-model="profileForm.phone"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Teaching Experience:"
                          prop="teachExprience"
                          required>
              <el-select v-model="profileForm.teachExprience"
                         placeholder="experience"
                         disabled>
              </el-select>
            </el-form-item>
            <el-form-item label="Teaching Certificate Number:"
                          prop="certificateNum"
                          required>
              <el-input v-model="profileForm.certificateNum"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Institution/School with excellent work experience:"
                          prop="institutionName">
              <el-input v-model="profileForm.institutionName"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Other experience:"
                          prop="workingExperience">
              <el-input type="textarea"
                        v-model="profileForm.workingExperience"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Urgent contact number"
                          prop="emergencyContact">
              <el-input v-model="profileForm.emergencyContact"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Contact email"
                          prop="contactEmail"
                          required>
              <el-input v-model="profileForm.contactEmail"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Birthday:"
                          prop="birthday"
                          required>
              <el-date-picker v-model="profileForm.birthday"
                              type="date"
                              placeholder="birthday"
                              disabled>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="QQ Number:"
                          prop="qq">
              <el-input v-model="profileForm.qq"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Use eClass:"
                          prop="liveTestUser"
                          required>
              <el-radio v-model="profileForm.liveTestUser"
                        disabled>Yes</el-radio>
            </el-form-item>
            <el-form-item label="Skype ID:"
                          prop="skype">
              <el-input v-model="profileForm.skype"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Graduated school"
                          prop="educationBackground"
                          required>
              <el-input v-model="profileForm.educationBackground"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Major"
                          prop="majoy"
                          required>
              <el-input v-model="profileForm.majoy"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Time zone difference"
                          prop="hourDiff"
                          required>
              <el-select v-model="profileForm.hourDiff"
                         placeholder="0"
                         disabled>
                <el-option v-for="item in timeList"
                           :key="item"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
              <div class="tips">
                0 hours means same time as Beijing. +1 hour means 1 hour ahead of Beijing time, -1 hour means you are 1 hour behind Beijing time.
              </div>
            </el-form-item>
            <el-form-item label="Upload the resume"
                          prop="major">
              <a style="text-decoration:underline;color:#666;"
                 :href="profileForm.resumeUrl">{{profileForm.resumeName}}</a>
            </el-form-item>
            <el-form-item label="English introduction"
                          prop="selfIntroduceEn"
                          required>
              <el-input type="textarea"
                        v-model="profileForm.selfIntroduceEn"
                        disabled></el-input>
            </el-form-item>
            <div class="line-block"></div>
            <el-form-item label="Bank account location (Country):"
                          prop="bankAccountCountry"
                          required>
              <el-input v-model="profileForm.bankAccountCountry"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Bank account location (City):"
                          prop="bankAccountCity"
                          required>
              <el-input v-model="profileForm.bankAccountCity"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Bank name:"
                          prop="bankName"
                          required>
              <el-input v-model="profileForm.bankName"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Account name:"
                          prop="bankAccountName"
                          required>
              <el-input v-model="profileForm.bankAccountName"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Account number:"
                          prop="bankAccountNumber"
                          required>
              <el-input v-model="profileForm.bankAccountNumber"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Branch bank address:"
                          prop="bankAddress"
                          required>
              <el-input v-model="profileForm.bankAddress"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Swift code:"
                          prop="bankSwiftCode"
                          required>
              <el-input v-model="profileForm.bankSwiftCode"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="Paypal:"
                          prop="paypal">
              <el-input v-model="profileForm.paypal"
                        disabled></el-input>
            </el-form-item>
            <div class="line-block"></div>
            <el-form-item class="cert-upload-wrap">
              <div class="cert-text">TEFEL and TESOL or other English teaching certifications uploading</div>
              <el-form-item class="cert-upload"
                            prop="certificateName1"
                            v-if="profileForm.certificateUrl1">
                <div class="avatar-img">
                  <img src="https://www.talk915.com/resourceProxy/fdfsDownload/group1/M00/00/3C/ooYBAFgiuYKEZEXyAAAAAI9OlEE035.png"
                       class="avatar" />
                </div>
                <a class="file-name"
                   :href="`${profileForm.certificateUrl1}?FILE_NAME=${profileForm.certificateName1}`">{{profileForm.certificateName1}}</a>
              </el-form-item>
              <el-form-item class="cert-upload"
                            prop="certificateName2"
                            v-if="profileForm.certificateUrl2">
                <div class="avatar-img">
                  <img :src="profileForm.certificateUrl2"
                       class="avatar" />
                </div>
                <a class="file-name"
                   :href="`${profileForm.certificateUrl2}?FILE_NAME=${profileForm.certificateName2}`">{{profileForm.certificateName2}}</a>
              </el-form-item>
              <el-form-item class="cert-upload"
                            prop="certificateName3"
                            v-if="profileForm.certificateUrl3">
                <div class="avatar-img">
                  <img :src="profileForm.certificateUrl3"
                       class="avatar" />
                </div>
                <a class="file-name"
                   :href="`${profileForm.certificateUrl3}?FILE_NAME=${profileForm.certificateName3}`">{{profileForm.certificateName3}}</a>
              </el-form-item>
            </el-form-item>
          </el-form>

        </div>
        <div class="info-block">
          <div class="info">
            <div class="info-img person"
                 v-if="profileForm.photoUrl1">
              <img :src="profileForm.photoUrl1"
                   alt="">
            </div>
            <div class="info-img person"
                 v-if="profileForm.photoUrl2">
              <img :src="profileForm.photoUrl2"
                   alt="">
            </div>
          </div>
          <div class="info">
            <div class="info-img person"
                 v-if="profileForm.idCardUrl">
              <img :src="profileForm.idCardUrl"
                   alt="">
            </div>
            <div class="info-img person"
                 v-if="profileForm.teaCerImgUrl">
              <img :src="profileForm.teaCerImgUrl"
                   alt="">
            </div>
          </div>
          <div class="info"
               v-if="profileForm.recordingUrl">
            <audio :src="profileForm.recordingUrl"
                   controls>
              您的浏览器不支持 audio 标签。
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
export default {
  created() {
    this.getMoreInfo();
  },
  data() {
    return {
      profileForm: {},
      timeList: [],
      experienceList: [],
      loading: false,
    };
  },
  methods: {
    async getMoreInfo() {
      this.loading = true;
      const res = await this.$api.getMoreInfoDetail();
      this.profileForm = res.data.resultData;
      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/ModifyInfo/MoreInfo/index.vue